export default __webpack_public_path__ + "static/media/13.3728f753.jpg";